<template>
  <CardContainer class="mt-5">
    <template v-slot:content>
      <v-row justify="center">
        <v-col cols="12" md="4">
          <v-text-field :label="text.fields.email" dense v-model="user.email" required/>
          <v-text-field
            :label="text.fields.password"
            type="password"
            dense
            v-model="user.password"
            required
          />
        </v-col>
      </v-row>
      <v-row justify="center">
        <v-btn @click="login" color="primary"
               :small = "$vuetify.breakpoint.mobile">{{ text.buttons.addressLoginTitle }}</v-btn>
      </v-row>
      <v-row justify="center">
        <v-col cols="12" class="text-center text-uppercase">{{ text.common.or }}</v-col>
      </v-row>
      <v-row justify="center">
        <v-btn @click="continueNoLogin" color="primary"
               :small = "$vuetify.breakpoint.mobile"
        v-html="text.buttons.addressLoginTitleContinue"/>
      </v-row>
    </template>
    <template v-slot:action>

    </template>
  </CardContainer>
</template>

<script>
import { translations } from '@/lang/translations';
import Axios from '@/core/Axios';
import CardContainer from '@/components/Partials/CardContainer.vue';
import { state } from '@/store';

export default {
  name: 'CartLogin',
  components: { CardContainer },
  props: ['currentStep'],
  data() {
    return {
      valid: false,
      user: {
        email: null,
        password: null,
      },
      axios: new Axios(),
    };
  },
  methods: {
    continueNoLogin() {
      this.$emit('continueNoLogin');
    },
    login() {
      this.axios.makeCall('POST', 'norbit/customer/login', this.user)
        .then((response) => {
          this.$store.commit('loginUser', {
            uid: response.customer.uid,
            username: response.customer.username,
            token: response.token,
          });
        })
        .catch((error) => {
          this.$store.dispatch('showSnackBar', {
            type: 'error',
            message:
              this.text.messages[error],
          });
        });
    },
  },
  computed: {
    text() {
      return translations[state.language];
    },
  },
};
</script>

<style scoped>

</style>
